// Code redemption page
(function() {
	if (document.querySelector('.code-redemption__module')) {
		if (document.getElementById('btn--enter-promo-flow')) {
			document.getElementById('btn--enter-promo-flow').addEventListener('click', function() {
				document.querySelectorAll('.code-redemption__module').forEach(function(element) {
					element.classList.toggle('hide');
				});
			});
		}

		if (document.getElementById('btn--yes')) {
			document.getElementById('btn--yes').addEventListener('click', function() {
				document.getElementById('create-user-form').style.display = 'none';
				document.querySelector('.code-redemption__options').style.display = 'none';
				document.getElementById('login-form').style.display = 'block';
			});
		}

		if (document.getElementById('btn--no')) {
			document.getElementById('btn--no').addEventListener('click', function() {
				document.querySelector('.code-redemption__options').style.display = 'none';
				document.getElementById('login-form').style.display = 'none';
				document.getElementById('create-user-form').style.display = 'block';
			});
		}
	}

	if (document.getElementById('code-redemption-payment-form')) {
		const promoCodes = [
			{
				code: 'ellenshow',
				description: `
					<p>After your 3-month promotion period, your Glo subscription will automatically continue at just $30/month.</p>
					<p>Your card will be charged $12.60 now - cancel anytime.</p>
				`
			}, {
				code: 'b4glo',
				description: `
					<p>After your 1-year promotion period, your Glo subscription will automatically continue at just $30/month.</p>
					<p>Your card will be charged $5 now - cancel anytime.</p>
				`
			}, {
				type: 'default',
				description: document.querySelector('.form-page__description').innerHTML
			}
		];

		document.querySelector('input[name="code"]').addEventListener('blur', function(e) {
			const code = e.target.value;
			const codeDesc = code ? promoCodes.find(promo => promo.code === code.toLowerCase()) : null;
			const descWrapper = document.querySelector('.form-page__description');
			codeDesc
				? descWrapper.innerHTML = codeDesc.description
				: descWrapper.innerHTML = promoCodes.find(promo => promo.type === 'default').description;
		});
	}
})();
